/* external links new window */
var links = document.links;
if (links.length > 0) {
  for(var i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].target !== '_self') {
      links[i].target = '_blank';
    }
  }
}
/*
Array.from(document.links).forEach(link => {
  if (link.hostname !== window.location.hostname && link.target !== '_self') {
    link.target = '_blank';
  }
});
*/

function getDistanceFromTop(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || window.pageYOffset;
  return rect.top + scrollTop;
}

/* to margin sidenav to first element */
const scroll_nav = document.getElementById('navbar-scroll');
if (scroll_nav) {
  const nav_warp = scroll_nav.querySelector('.side-nav');
  const first_c_item = document.querySelector('.fix-nav-item');
  if (nav_warp && first_c_item) {
    let distance_diff = getDistanceFromTop(first_c_item) - getDistanceFromTop(nav_warp);
    if (distance_diff > 0) {
      nav_warp.style.paddingTop = distance_diff+'px';
    }
  }
}

/* affix scroll 
window.onscroll = scroll;

const navlist = document.getElementById("navbar-main");
const sticky = navlist.offsetTop;

function scroll () {
  var scrollTop = window.pageYOffset;

  if( scrollTop > 100 ){
    navlist.classList.add("affix");
  }
  else
  {
    navlist.classList.remove("affix");
  }
}*/

/* embed iframe responisve 
var wrap = (query, tag) => {
  document.querySelectorAll( query ).forEach( elem => {
    const div = document.createElement(tag);
    elem.parentElement.insertBefore(div, elem);
    div.appendChild(elem);
    div.className = 'embed-container';
  });
};

wrap('iframe', 'div');*/